module.exports = __webpack_public_path__ + "img/bg.a3e95f26.jpg";